// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-container.cards[data-v-4080b003]{flex-direction:column;margin-top:2rem}.card-amo[data-v-4080b003],.card-contact[data-v-4080b003],.card-customer[data-v-4080b003]{min-width:400px;display:flex;flex-direction:column;margin-bottom:2rem}.row-bg[data-v-4080b003]{flex-wrap:wrap}", ""]);
// Exports
module.exports = exports;
